import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  Pause,
  PlayArrow,
  Stop,
  Save,
  Delete,
  Check as CheckIcon,
} from "@mui/icons-material";
import CustomAudioPlayer from "./AudioPreview";
import aduioGIF from "../../../assets/5404d46b-6c7b-4bae-88b3-6cfd12c07124.gif";
const AudioRecorder = ({ handleChange, audioFile, toggleAudio }) => {
  const [recording, setRecording] = useState(false);
  const [mp3Blob, setMp3Blob] = useState(null);
  const [open, setOpen] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const [timer, setTimer] = useState(0);
  const intervalRef = useRef(null);
  const [extension, setExtension] = useState("");
  const isMobile = useMediaQuery("(max-width: 600px)");

  const micRecorderRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startCountdown = () => {
    setCountdown(3);
    const countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);
    setTimeout(() => {
      clearInterval(countdownInterval);
      setCountdown(null);
    }, 3000);
    setTimeout(() => {
      startRecording();
    }, 2000); // Start the recording 200 milliseconds before the countdown ends
  };

  const startRecording = () => {
    console.log("Recording starts");
    audioChunksRef.current = [];
    setTimer(0);
    intervalRef.current = setInterval(() => {
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);
    var options = {
      audioBitsPerSecond: 256000,
      videoBitsPerSecond: 2500000,
      bitsPerSecond: 2628000,
      mimeType: "audio/" + extension + ";codecs=opus",
    };

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorderRef.current = mediaRecorder;

        mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            audioChunksRef.current.push(event.data);
          }
        };

        mediaRecorder.onstop = () => {
          const audioBlob = new Blob(audioChunksRef.current, {
            type: "audio/" + extension,
            bitsPerSecond: 128000,
          });
          setMp3Blob(audioBlob);
          setRecording(false);
        };

        mediaRecorder.start();
        setRecording(true);
      })
      .catch((error) => {
        console.error("Error starting recording:", error);
      });
  };

  const stopRecording = () => {
    clearInterval(intervalRef.current);
    const mediaRecorder = mediaRecorderRef.current;
    if (mediaRecorder && recording) {
      mediaRecorder.stop();
    }
  };

  const handleSave = () => {
    const uniqueFile = new File([mp3Blob], `${Date.now()}.mp3`, {
      type: "audio/mpeg",
    });
    const fileObject = {
      file: uniqueFile,
      metadata: {
        duration: timer,
        type: uniqueFile.type,
        size: uniqueFile.size,
      },
    };
    // here handleChange should recieve: {file: fileObject, metadata: metadataObject}
    handleChange(fileObject);
    setOpen(true);
    if (toggleAudio) {
      toggleAudio();
    }
    setTimeout(() => {
      setOpen(false);
    }, 3000); // Close the dialog after 3 seconds
  };
  const handleDelete = () => {
    setMp3Blob(null);
    setOpen(false);
  };
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };
  useEffect(() => {
    setMp3Blob(audioFile);
  }, [audioFile]);

  useEffect(() => {
    if (MediaRecorder.isTypeSupported("audio/webm;codecs=opus")) {
      setExtension("webm");
    } else {
      setExtension("ogg");
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {mp3Blob ? (
        <>
          <CustomAudioPlayer
            audioFile={mp3Blob ? URL.createObjectURL(mp3Blob) : ""}
            duration={timer}
            redoFunction={handleDelete}
            showSave={true}
            showControl={false}
            handleSave={handleSave}
            sliderColor={"primary"}
          />
        </>
      ) : (
        <>
          {countdown ? (
            <Typography variant="h6" style={{ color: "#CB3535" }}>
              {countdown}
            </Typography>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {recording && timer > 0 && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={aduioGIF}
                    alt="audio gif"
                    style={{
                      maxHeight: "50%",
                      width: "auto",
                      height: "auto",
                      maxWidth: "100%",
                      marginBottom: isMobile ? "8px" : "0",
                    }}
                  />
                  <Typography
                    variant={isMobile ? "body1" : "body2"}
                    color="textSecondary"
                    style={{
                      margin: isMobile ? "4px 0" : "0 4px",
                      textAlign: isMobile ? "center" : "initial",
                    }}
                  >
                    {formatTime(timer)}
                  </Typography>
                </div>
              )}
              <Button
                onClick={recording ? stopRecording : startCountdown}
                startIcon={
                  recording ? (
                    <Stop style={{ color: "white" }} />
                  ) : (
                    <PlayArrow />
                  )
                }
                style={{
                  backgroundColor: recording ? "#CB3535" : "#3576CB",
                  marginTop: "10px",
                  marginBottom: "10px",
                  color: recording ? "white" : "white",
                  padding: "20px",
                }}
                color={recording ? "secondary" : "primary"}
              >
                {recording ? "Stop Recording" : "Start Recording"}
              </Button>
            </div>
          )}
        </>
      )}
      <Dialog open={open} aria-labelledby="dialog-title">
        <DialogContent
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            padding: "16px",
          }}
        >
          <div
            style={{
              margin: "16px",
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "green",
              border: "4px solid gray",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckIcon style={{ color: "white", fontSize: "28px" }} />
          </div>
          <div style={{ margin: "16px", fontSize: "16px" }}>Audio Saved</div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AudioRecorder;
